import React from 'react'
import IconButton from '@mui/material/IconButton';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import { useDarkModeStore } from '../../../../../store/useDarkModeStore';
import { ReactComponent as SideBarOpen } from '../../../../../images/sidebar-open.svg'

interface FilterBtnProps {
    showFilters: boolean;
    setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FilterBtn: React.FC<FilterBtnProps> = ({ showFilters, setShowFilters }) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();

    return <IconButton
        aria-label="Filters"
        title={showFilters ? language['RemoveFilter'] : language['ShowFilter']}
        sx={{ color: darkMode ? 'white' : '#6E7174' }}
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowFilters(!showFilters)
        }}
    >
        <SideBarOpen
            width="24"
            height="24"
            className={`filter-icon ${showFilters ? 'open' : 'close'}`}
        />
    </IconButton>
}
export default FilterBtn